module.exports = __webpack_public_path__ + "static/media/apps.22b4aa5d.webp";